export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'b131d826-cee8-437e-903a-883f495f93a9';
export const MODAL_CLOSE_SEC = 2.5;
